import { openDrawer, closeDrawer, overflowAdd, overflowRemove, trapFocus } from '@lib/pubsub';
if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();
        console.log('working');

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);

      }
 
      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
          this.drawerTemplate = null;
        }
      }

      
      showDrawer(button) {
        // Remove any existing drawer from body
        const existingDrawer = document.querySelector('pickup-availability-drawer');
        if (existingDrawer) existingDrawer.remove();

        if (!this.drawerTemplate) return;

        // Create drawer from template and append to body
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.drawerTemplate;
        const drawer = tempDiv.firstElementChild;

        if (drawer) {
          document.body.appendChild(drawer);
          const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
          colorClassesToApply.forEach((colorClass) => {
            document.querySelector('pickup-availability-drawer').classList.add(colorClass);
          });
          setTimeout(() => {
            drawer.show(button);
          }, 200);
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);
        if (this.querySelector('[data-pickup-drawer]')) {
         
          this.querySelector('[data-pickup-drawer]').addEventListener('click', (event) => {
            this.onClickRefreshList(event);
            const getActiveButton = document.querySelector('.pickup-availability-active-button');
            if(getActiveButton){
              getActiveButton.classList.remove('pickup-availability-active-button');
            }
            event.currentTarget.classList.add('pickup-availability-active-button');
          });

        }

      }

      renderPreview(sectionInnerHTML) {
        // const drawer = document.querySelector('pickup-availability-drawer');
        // if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        const drawerTemplate = sectionInnerHTML.querySelector('pickup-availability-drawer');
        if (drawerTemplate) {
          this.drawerTemplate = drawerTemplate.outerHTML;
        }
        // document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));


        const button = this.querySelector('[data-pickup-drawer]');
        if (button)
          button.addEventListener('click', (evt) => {
            this.showDrawer(evt.target);
          });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

      }
      connectedCallback() {
        const closeButtons = [
          this.querySelector('[data-offcanvas-close]'),
          this.querySelector('[offcanvas-close]')
        ];

        closeButtons.forEach((btn) => {
          if (btn) {
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              this.hide(this.drawername);
            });
          }
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide(this.drawername);
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }
      
      hide() {
        this.classList.remove('offcanvas-open');
        this.removeAttribute('open');
        overflowRemove();
        setTimeout(() => {
          const getActiveButton = document.querySelector('.pickup-availability-active-button');
          if(getActiveButton){
            getActiveButton.focus();
            getActiveButton.classList.remove('pickup-availability-active-button');
          }
        }, 300);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        this.classList.add('offcanvas-open');
        overflowAdd();
        setTimeout(() => {
          trapFocus(this);
        }, 500);
      }
    }
  );
}

